var map = {
	"./custom/app/header-nav-wrapper/header-navbar-wrapper.component": [
		"TCj9",
		55
	],
	"./dspace/app/header-nav-wrapper/header-navbar-wrapper.component": [
		"WgVi",
		84
	],
	"./rd_senado/app/header-nav-wrapper/header-navbar-wrapper.component": [
		"0Ku0",
		100
	],
	"./rd_senado_cms/app/header-nav-wrapper/header-navbar-wrapper.component": [
		"Hk86",
		142
	],
	"./rd_senado_faq/app/header-nav-wrapper/header-navbar-wrapper.component": [
		"XYh1",
		185
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "K/Po";
module.exports = webpackAsyncContext;